(ns storrito.instagram.story.editor.dimension)

(def canvas-margins
  [600 100])

;;; Instagram image sizes based on
;;; https://colorlib.com/wp/size-of-the-instagram-picture/

(def square-image
  {:width 1080
   :height 1080})

(def vertical-image
  {:width 1080
   :height 1350})

(def horizontal-image
  {:width 1080
   :height 566})

(def story-image
  {:width 1080
   :height 1920})

(def scalable-keys [:image/width
                    :image/height
                    :canvas/width
                    :canvas/height
                    :margin/top
                    :margin/left
                    :margin/bottom
                    :margin/right])

(defn scale [dimensions scale-factor]
  (reduce (fn [dimensions* key]
            (update dimensions* key (partial * scale-factor)))
          dimensions
          scalable-keys))

(defn dimensions [image-size]
  (let [{:keys [width height]} image-size
        [margin-width margin-height] (if (< width height)
                                       canvas-margins
                                       (reverse canvas-margins))
        editor-canvas (js/document.getElementById "fabricjs-canvas")
        h (if (nil? editor-canvas)
            1000
            (.-offsetHeight editor-canvas))
        w (if (nil? editor-canvas)
          1000
          (.-offsetWidth editor-canvas))
        canvas-width (+ width
                       (* margin-width 2))
        canvas-height (+ height
                        (* margin-height 2))]

    #_(js/console.log (pr-str  canvas-height "CANVAS " h))

    {:image/width width
     :image/height height
     :canvas/width canvas-width
     :canvas/height canvas-height
     :margin/top margin-height
     :margin/left margin-width
     :margin/bottom margin-height
     :margin/right margin-width
     :dimension/image-size image-size}))

(defn for-model [model-value]
  (assert (:dimension/image-size model-value))
  (let [image-size (:dimension/image-size model-value)]
    (cond-> (dimensions image-size)
      (:canvas/hide-margins? model-value)
      (assoc :canvas/width (:width image-size)
             :canvas/height (:height image-size)
             :margin/top 0
             :margin/left 0
             :margin/bottom 0
             :margin/right 0))))
